import { render, staticRenderFns } from "./vendor-category.vue?vue&type=template&id=b7a6ac24&scoped=true&"
import script from "./vendor-category.vue?vue&type=script&lang=js&"
export * from "./vendor-category.vue?vue&type=script&lang=js&"
import style0 from "./vendor-category.vue?vue&type=style&index=0&id=b7a6ac24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a6ac24",
  null
  
)

export default component.exports